import { Typography } from "@material-tailwind/react";

export function TypographyColors() {
  return (
    <>
      <Typography variant="h1" color="blue-gray">
        Material Tailwind
      </Typography>
      <Typography variant="h1" color="blue">
        Material Tailwind
      </Typography>
      <Typography variant="h1" color="red">
        Material Tailwind
      </Typography>
      <Typography variant="h1" color="green">
        Material Tailwind
      </Typography>
    </>
  );
}
